<template>
    <div class="box" v-if="selectMemberModels.isShow">
        <div class="mask-box" @click.stop.prevent="cancel"></div>
        <div class="querter-box">
            <h4 class="search" style="margin:20px 0;width:100%;padding:0"><input @click="activeName='部门'"  type="text" v-on:keyup.enter="loadData" v-model="searchText" style="float:left;height:28px;border:1px solid #e7e7e7;padding-left:10px;font-size:12px" placeholder="查询人员名称"></h4>
            <div class="tab" style="width: 330px;">
                <div @click="changetab('部门')"
                    :style="{color:(activeName=='部门'?'#3B8CFF':'#333'),borderBottomColor:(activeName=='部门'?'#3B8CFF':'transparent')}">
                    <span  :class="{active:activeName=='部门'}">部门</span>
                </div>
                <div @click="changetab('常用联系人')"
                    :style="{color:(activeName=='常用联系人'?'#3B8CFF':'#333'),borderBottomColor:(activeName=='常用联系人'?'#3B8CFF':'transparent')}">
                    <span  :class="{active:activeName=='常用联系人'}">常用联系人</span>
                </div>
                <div v-if="activeName=='常用联系人'" style="margin-top: -5px;float: right;">
                    <el-button type="danger" size="mini" @click="deleteAllSelect">批量删除</el-button>
                </div>
            <!-- <div @click="changetab('项目')"
                :style="{color:(activeName=='项目'?bgColor:'#999'),borderBottomColor:(activeName=='项目'?bgColor:'transparent')}">
                <span  :class="{active:activeName=='项目'}">项目</span>
            </div> -->
           </div>
            <div v-if="activeName=='部门'" style="height:100%">

                <div class="querter-list-box">
                    <div class="item-box">
                        <selectProjectItem :parentCmpId="id" :btnFlag="false" v-for="(item, index) in models"  :key="index" :models="item" :level="level" :radioSelectFlags="true" :selectProjectNode="selectProjectNode"></selectProjectItem>
                    </div>
                </div>
                <div class="select-list">
                    <div class="item-box" style="border:0 none;display: flex;flex-flow: column;">
                        <el-table ref="quertPeopleTable" :data="QuertPeopleList"
                        size="mini"
                        border @row-click="actives"
                        :cell-style="{textAlign:'center',}"
                        height="100%"
                        id="el-table"
                        :header-cell-style="headerCell"
                        highlight-current-row
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection" v-if="!selectMemberModels.radioSelectFlags"></el-table-column>
                        <el-table-column   label="姓名" min-width="130">
                            <template slot-scope="scope">
                                <div>
                                    <img :src="scope.row.url" alt="">
                                    <span style="white-space: nowrap;text-align:left">
                                     <wx-show-data type="userName" :openid="scope.row.userName" />

                                  </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column   label="常用联系人" min-width="85" >
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="addSelect(scope.row)" icon="el-icon-plus"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                      <el-pagination
                        small
                        @current-change="((pageIndex)=>{handleCurrentChange( pageIndex)})"
                        layout="prev, pager, next"
                        :current-page="pageIndex"
                        :page-size="pageSize"
                        :page-sizes="[100, 200, 300, 400]"
                        :total="totalCount">
                      </el-pagination>
                    </div>
                </div>
            </div>

            <div v-show="activeName=='常用联系人'" style="height:100%">
                <div class="select-list select-list2">
                    <div class="item-box" style="border:0 none;">
                        <el-table ref="linkUserTable" :data="linkPeopleList"
                            :fit="true" size="mini"
                            border @row-click="actives"
                            :cell-style="{textAlign:'center'}" height="362"
                            :header-cell-style="headerCell"
                            highlight-current-row
                                  @select="handlerLinkSelect"
                            @selection-change="handlerLinkChange">
                        <el-table-column type="selection" width="40" v-if="!selectMemberModels.radioSelectFlags"></el-table-column>
                        <el-table-column label="姓名" >
                            <template slot-scope="scope">
                                <div>
                                    <img :src="scope.row.url" alt="">
                                    <span style="white-space: nowrap;text-align:left">
                                      <wx-show-data type="userName" :openid="scope.row.userName" />

                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column  label="岗位" >
                            <template slot-scope="scope">
                                <button style="width:46px;height:22px;background: #FF6363;border-radius: 4px;color:#fff">{{ scope.row.departName}}</button>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="删除常用联系人" >
                            <template slot-scope="scope">
                                <button type="button" style="width:46px;height:22px;background: #FF6363;border-radius: 4px;color:#fff" @click="deleteSelect(scope.row)">一</button>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </div>
            </div>
            <div v-show="activeName=='项目'" style="height:100%">
                <div class="select-list select-list2">
                    <div class="item-box" style="border:0 none;">
                        <el-table ref="multipleTable" :data="projPeopleList"
                        size="mini"
                        border
                        :cell-style="{textAlign:'center'}"
                        height="460"
                        :header-cell-style="headerCell"
                        highlight-current-row
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="40"></el-table-column>
                        <el-table-column label="姓名" >
                            <template slot-scope="scope">
                                <div>
                                    <img :src="scope.row.url" alt="">
                                    <span style="white-space: nowrap;text-align:left">{{ scope.row.label }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="岗位" >
                            <template slot-scope="scope">
                                <button style="width:46px;height:22px;background: #FF6363;border-radius: 4px;color:#fff" >{{ scope.row.departName}}</button>
                            </template>
                        </el-table-column>
                        <el-table-column label="项目负责人" >
                            <template slot-scope="scope">
                                <button type="button" style="width:46px;height:22px;background: #FF6363;border-radius: 4px;color:#fff" >{{ scope.row.departName}}</button>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </div>
            </div>
             <div  class="select-list select-list1">
                    <h4 style="margin:20px 0;width:100%;"><i></i>已选人员({{selectList.length}})</h4>
                    <div class="item-box" style="border:0 none;">
                        <el-table :data="selectList"
                        size="mini"
                        border
                        :cell-style="{textAlign:'center',}"
                        height="100%"
                        id="el-table"
                        :header-cell-style="headerCell"
                        highlight-current-row
                        @selection-change="handleSelectionChange">
                        <el-table-column label="人员"  width="160">
                            <template slot-scope="scope">
                                <div>
                                    <img :src="scope.row.url" alt="">
                                    <span style="white-space: nowrap;text-align:left">
                                      <wx-show-data type="userName" :openid="scope.row.userName" />

                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="部门" >
                            <template slot-scope="scope">
                                <button style="width:46px;height:22px;background: #FF6363;border-radius: 4px;color:#fff">{{scope.row.departName}}</button>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="操作" >
                            <template slot-scope="scope">
                                <button type="button" style="width:46px;height:22px;background: #3B8CFF;border-radius: 4px;color:#fff" @click="cancelSelect(scope.row)">一</button>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </div>

            <div class="footer-btn">
                <el-button type="button" @click="cancel" size="small">关闭</el-button>
                <el-button type="primary" size="small" @click="success">确定</el-button>
                <!-- <el-button v-if="selectMemberModels.showAddBtn" type="success" size="small" @click="$modal.show('add-modal')">添加人员</el-button> -->
            </div>
        </div>
        <modal name="add-modal" class="theme-modal" height="auto" transition="pop-out" :width="810"  :draggable="true">
            <div class="title">
                <p>添加人员</p>
                <i @click="$modal.hide('add-modal')" class="el-icon-close"></i>
            </div>
			      <div class="content">
                <el-form :model="userObj" :rules="rules" ref="empForm" label-width="80px">
                    <el-form-item label="姓名" required>
                        <el-col :span="9">
                            <el-form-item prop="userName">
                              <el-input size="mini" v-model="userObj.userName" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="line-title">身份证号</el-col>
                        <el-col :span="9">
                            <el-input size="mini" type="number" v-model="userObj.idCard" placeholder="请输入身份证号"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="联系方式" required>
                        <el-col :span="9">
                            <el-form-item prop="mobileNo">
                              <el-input size="mini" type="number" v-model="userObj.mobileNo" placeholder="请输入联系方式"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="line-title">年龄</el-col>
                        <el-col :span="9">
                            <el-input size="mini" type="number" v-model="userObj.birthday" placeholder="请输入年龄"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="学历">
                        <el-col :span="9">
                            <el-input size="mini" v-model="userObj.LEVEL_" placeholder="请输入学历"></el-input>
                        </el-col>
                        <el-col :span="6" class="line-title">工作年限</el-col>
                        <el-col :span="9">
                            <el-input size="mini" v-model="userObj.PERIODS_" placeholder="请输入工作年限"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="岗位" required>
                        <el-col :span="9">
                          <el-form-item prop="positionName">
                            <el-input size="mini" @focus="selectFormData('t_sys_position')" v-model="userObj.positionName" placeholder="请选择岗位" suffix-icon="el-icon-more"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6" class="line-title"><i>*</i>所属公司</el-col>
                        <el-col :span="9">
                            <el-form-item prop="departName">
                              <el-input size="mini" @focus="selectFormData('t_sys_supplier')" v-model="userObj.departName" placeholder="请选择所属公司" suffix-icon="el-icon-more"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="角色:" prop="roleName">
                        <el-input size="mini" @focus="selectFormData('t_sys_roles')" v-model="userObj.roleName" placeholder="请选择角色" suffix-icon="el-icon-more"></el-input>
                    </el-form-item>
                    <el-form-item label="备注:">
                        <el-input v-model="userObj.REMARK_"  placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-form>
                
                
            </div>
            <div class="modal-footer">
                <el-button size="mini" @click="$modal.hide('add-modal')">关闭</el-button>
                <el-button size="mini" type="primary" @click="saveUser">保存</el-button>
            </div>
		    </modal>

        <modal name="data-modal" class="theme-modal" height="auto" transition="pop-out" :width="860" :draggable="true">
          <div class="modal-content">
              <form-view :on-load="setFormWidth" :hasTitle="false" :readOnly="true"
                @confirmSelect="confirmSelect"  :queryParams="selectFormQueryParams" :isModal="true" 
                :select-form-key="defaultFormKey" :single-select="true" ref="select-form">
              </form-view>
          </div>
          <div class="modal-footer">
              <el-button size="mini" type="primary" @click="confirmSelect">确定</el-button>
              <el-button size="mini" @click="$modal.hide('data-modal')">关闭</el-button>
          </div>
        </modal>
    </div>
</template>
<script>
import selectProjectItem from '../base/asideItemTree/asideItem'
import {tableMixin} from '../../public/js/mixins.js'
import { mapMutations, mapGetters } from 'vuex'
export default {
  props: ['selectMemberModels'],
  mixins: [tableMixin],
  data () {
    return {
      rules:{
        userName: [
            { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        mobileNo: [
            { required: true, message: '请输入联系方式', trigger: 'change' }
        ],
        positionName: [
            { required: true, message: '请选择岗位', trigger: 'change' }
        ],
        departName: [
            { required: true, message: '请选择公司', trigger: 'change' }
        ],
        roleName: [
            { required: true, message: '请选择角色', trigger: 'change' }
        ],
      },
      formObj:{
        "t_sys_position":{
          positionUid:"POST_",
          positionName:"POST_LABEL_",
        },
        "t_sys_supplier":{
          departUid:"UN_COMPANY_",
          departName:"UN_COMPANY_LABEL_",
        },
        "t_sys_roles":{
          roleUid:"ROLE_UID_",
          roleName:"ROLE_UID_LABEL_",
        },
      },
      defaultFormKey: 'project-info',
      selectFormQueryParams: null, // 选择弹框表单时查询传参，默认把表单数据传过去
      userObj:{},
      id: new Date().getTime()+Math.ceil(Math.random()*10),
      dialogVisible: false,
      searchText: '',
      pageSize: 30,
      pageIndex:1,
      totalCount:0,
      pageCount:0,
      activeName: '部门',
      level: 0,
      initing:false, // 是否正在初始化
      selectNode: {},
      QuertPeopleList: [],
      linkPeopleList: [],
      projPeopleList: [],
      loadingUser:false,
      loadingUserCount:0,
      loadingUserTimer:null,
      selectList: [],
      models: [],
      user: {},
      selectProjectNode: {
        id: ''
      },
      userList:[],
      selectedSelection: {},
      commonlySelectList:[],
      checkedArrData: []
    }
  },
  components: {selectProjectItem},
  computed: {
    ...mapGetters([
      'getFormConfig',
      'formSelectData',
      'getLinkUsers',
      'orgDatas'
    ])
  },
  created () {
    // console.log('-------select-user---------')
    this.bgColor = this.$store.state.themeColor
    this.fontColor = this.$store.state.themeBG
    this.$bus.on('handelDepart', this.addOrEditDepart)
    // this.selectList = this.selectMemberModels.selectList
    this.selectList =[]
    this.user = this.sessionUtil.getUser()
    this.loadAsideData()
    this.selectNode.id = ''
    this.loadData()
    /*setTimeout(() => {
      this.toggleSelection(this.selectList)
    }, 100);*/
    // console.log(this)
  },
  mounted () {
    // console.log('---------')
    this.$nextTick(() => {
      this.selectList = this.selectMemberModels.selectList
      this.selectedSelection = {}
      /*let arr = []
      this.QuertPeopleList.forEach((item, index) => {
        this.selectList.forEach((prod) => {
          if (item.id == prod.id) {
            arr.push(item)
          }
        })
      })*/
      // this.snyc(arr)
      /*this.$nextTick(() => {
        this.initCheckData()
      })*/
    })
  },
  beforeDestroy () {
    this.$bus.off('handelDepart', this.addOrEditDepart)
  },
  watch: {
    'selectMemberModels.isShow' (newVal, oldVal) {
      console.log('----selectMemberModels.isShow----', newVal)
      if (newVal) {
        // if(this.selectMemberModels.radioSelectFlags) {
        //    this.selectList= this.selectMemberModels.selectList
        // }
        this.$nextTick(() => {
          console.log('---------this.selectList--------',this.selectMemberModels.selectList)
          /*this.selectList = []
          return*/
          this.selectList = this.selectMemberModels.selectList
          this.$nextTick(() => {
            this.initCheckData()
          })
          // this.snyc(arr)
        })
      }
    }
  },
  methods: {
    ...mapMutations([
      'setFormConfig',
      'setFormSelectData',
      'setOrgDatas',
      'setLinkUsers'
    ]),
    actives (node) {
      if (this.selectMemberModels.radioSelectFlags) {
        var arr = []
        arr.push(node)
        this.selectList = arr
        this.success()
      }
    },
    //新增人员
    saveUser(){
      this.$refs.empForm.validate((valid) => {
        if (valid){
          this.util.mask("正在保存..");
          this.util.restPost("/api_v1/platform/users",this.userObj,(res)=>{
              this.util.unmask();
              if(res.status==200){
                this.util.success("保存成功!");
                let user={
                  id:res.data.id,
                  userName:res.data.userName,
                }
                this.selectList.push(user);
                this.$modal.hide('add-modal');
              }else{
                  this.util.error(res.errorMsg)
              }
          });
        }
      });
     
    },
    selectFormData(formKey){
      this.defaultFormKey = formKey;
      this.$modal.show('data-modal');
    },
    // 弹框回调
    setFormWidth (formConfig) {
      //this.selectFormConfig = formConfig
    },
    confirmSelect(){
      let selectedData = []
      let selectForm = this.$refs['select-form']
      if (selectForm && selectForm.getSelectedData) {
          selectedData = selectForm.getSelectedData()
      }
      if(selectedData.length==0){
          this.util.error("请选择数据");
          return
      }
      let data =selectedData[0];
      let backObj =this.formObj[this.defaultFormKey];
      for(let key  in backObj){
          this.$set(this.userObj,key,data[backObj[key]]);
      }
      this.$modal.hide('data-modal');
    },
    // 切换选择状态
    toggleSelection (rows) {
      if (rows) {
        if (this.$refs.quertPeopleTable) {
          rows.forEach(row => {
            let data = this.QuertPeopleList.find(item => item.userName === row.userName);
            this.$refs.quertPeopleTable.toggleRowSelection(data)
          })
        }
      } else {
        this.$refs.quertPeopleTable.clearSelection();
      }
    },
    addSelect (data) {
      var o = {
        linkUid: data.id,
        userUid: this.user.id
      }
      // console.log(o)
      var arr = [o]
      var param = {
        Authorization: this.sessionUtil.getAccessToken(),
        id: this.user.id,
        _list: arr
      }
      this.util.restPost('/api_v1/org/users/{id}/links', param, (res) => {
        if (res.status == 200) {
          this.setLinkUsers(null)
          this.util.success('添加成功')
          // this.linkPeopleList=res.data;
          // this.$forceUpdate()
        } else {
          this.util.error(res.msg)
        }
      })
    },
    // 批量删除常用联系人
    deleteAllSelect () {
      let params = this.commonlySelectList.map(item =>{
          return {linkUid: item.id}
      })
      this.util.confirm('确定要删除选中常用联系人?',null,(result) => {
        this.util.mask("正在删除..");
          this.util.restPost('/api_v1/org/users/' + this.user.id + '/links/delete', params, (res) => {
            this.util.unmask();
            if(res.status==200){
                this.setLinkUsers(null)
                this.util.success("删除成功！");
                this.loadOftendata()
            }else {
                this.util.error(res.errorMsg);
            }

        });
      });
    },
    deleteSelect (data) {
      var param = {
        Authorization: this.sessionUtil.getAccessToken(),
        id: this.user.id,
        linkUid: data.id
      }
      this.util.restDelete('/api_v1/org/users/{id}/links/{linkUid}', param, (res) => {
        if (res.status == 200) {
          this.util.success('删除成功')
          this.setLinkUsers(null)
          this.loadOftendata()
          // this.linkPeopleList=res.data;
          // this.$forceUpdate()
        } else {
          this.util.error(res.msg)
        }
      })
    },
    changetab (str) {
      this.activeName = str
      if (str == '常用联系人') {
        this.loadOftendata()
      } else if (str == '项目') {

      } else {
        this.loadAsideData()
        this.$nextTick(() => {
          this.initCheckData()
        })
      }
    },

    loadAsideData () {
      var param = {
        Authorization: this.sessionUtil.getAccessToken(),
        companyUid: this.sessionUtil.getCompanyUid(),
        type: 'depart',
        projType: this.searchText
      }
      // 设置缓存
      if (this.orgDatas && this.orgDatas.id) {
        this.models[0] = (this.orgDatas)
        this.$forceUpdate()

        return
      }
      this.util.restGet('/api_v1/org', param, (res) => {
        // console.log(res)
        if (res.status == 200) {
          this.models[0] = res.data
          this.$forceUpdate()
          this.setOrgDatas(res.data)
        } else {
          this.util.error(res.msg)
        }
      })
    },
    loadOftendata () {
      var param = {
        Authorization: this.sessionUtil.getAccessToken(),
        id: this.user.id
      }
      this.initing = true
      let linkUsers = this.getLinkUsers
      if (linkUsers && linkUsers.length > 0) {
        this.linkPeopleList = linkUsers
        this.$nextTick(() => {
          this.initCheckData()
        })
      } else {
        this.util.restGet('/api_v1/org/users/{id}/links', param, (res) => {
          if (res.status === 200) {
            this.linkPeopleList = res.data
            this.setLinkUsers(res.data)
            this.$forceUpdate()
          } else {
            this.util.error(res.msg)
          }
          this.$nextTick(() => {
            this.initCheckData()
          })
        })
      }
    },
    initCheckData(){ // 切换标签初始化数据
      this.initing = true
      let str = this.activeName
      let tableData = []
      let tableRef = null
      // console.log(str+'-----initCheckData----',str,this.selectList)
      if (str === '常用联系人') {
        tableData = this.linkPeopleList
        tableRef = this.$refs.linkUserTable
        // this.$refs.linkUserTable.clearSelection()


      } else if (str === '项目') {

      } else {
        tableData = this.QuertPeopleList
        tableRef = this.$refs.quertPeopleTable
      }
      let data = []
      // console.log(str+'-----initCheckData--1--',tableRef,tableData)
      if(tableRef && tableData){
        tableData.forEach(row=>{
          let rows = this.selectList.filter(item=>{
            return item.id === row.id
          })
          // console.log(row.userName+'-------',rows)
          if(rows && rows.length>0){
            tableRef.toggleRowSelection(row,true)
            data.push(row)
            // tableRef.toggleRowSelection(row, true)

          }else{
            tableRef.toggleRowSelection(row,false)
          }

        })
        // console.log(str+'-----initCheckData----',this.selectNode.id,data)
        if (str === '常用联系人') {

        } else if (str === '项目') {

        } else {
          this.commonlySelectList = data
          if(!this.selectedSelection[this.selectNode.id]){
            this.selectedSelection[this.selectNode.id] = {}
          }
          this.selectedSelection[this.selectNode.id][this.pageIndex] = data
        }

      }

      this.initing = false
    },
    addOrEditDepart (data,slide,id) {
      // console.log(this.id+'-----addOrEditDepart-----',id,this.loadingUserCount,this.loadingUser)
      // 避免bus重复执行
      if(id && this.id === id){
        // console.log(data.id+'-----------'+this.selectNode.id)
        if(this.selectNode&& this.selectNode.id === data.id){

        }else{
          this.userList = []
        }

        this.selectNode = data
        this.pageIndex = 1
        this.loadData()
      }
      /*clearTimeout(this.loadingUserTimer)
      this.loadingUserTimer = setTimeout(()=>{
        this.syncLoadData(data)
      },50)*/
      // this.loadingUser = false
    },
    syncLoadData(data){
      // console.log('-----syncLoadData-----',this.loadingUserCount,this.loadingUser)

      // this.loadingUser = true
      this.selectNode = data
      this.pageIndex = 1
      this.loadData()
      // this.loadingUserCount = 0
      // this.loadingUser = falsethis.id+
    },
    handleCurrentChange( pageIndex){
      this.pageIndex = pageIndex
      this.loadData()
    },
    loadData () {
      // console.log('------loadData-------',this.selectNode)
      var _this = this
      var param = {
        Authorization: this.sessionUtil.getAccessToken(),
        companyUid: this.$store.state.companyUid,
        departUid: this.selectNode.id,
        ifContainChild: true, // 默认递归查找下级用户
        // positionUid:'',
        // roleUid:false,
        // ifContainChild:false,
        // ifQueryPosition:true,
        // start: 0,
        containQuit:false,
        start : (this.pageIndex-1)*this.pageSize,
        pageSize: this.pageSize,
        search: this.searchText
      }
      /*if (this.validUtil.isNull(this.searchText) &&  _this.getFormConfig['_org_user_' + _this.selectNode.id]) {
        this.initing = true
        _this.QuertPeopleList = _this.getFormConfig['_org_user_' + _this.selectNode.id].data

        this.$forceUpdate()
        this.$nextTick(() => {
          this.initCheckData()
        })
      } else {*/
        this.initing = true
        _this.util.restGet('/api_v1/org/users', param, (res) => {

          if (res.status == 200) {
            if (res.data == undefined || res.data.length === 0) {
              _this.pageCount = 0
              _this.totalCount = 0
            } else {
              _this.totalCount = res.totalCount
              _this.pageCount = (_this.totalCount + _this.pageSize - 1) / _this.pageSize
            }
            _this.QuertPeopleList = res.data
            let obj = {
              formKey: '_org_user_' + _this.selectNode.id,
              data: res.data
            }
            _this.setFormConfig(obj)
            this.$forceUpdate()
            // _this.snyc(_this.selectList)
          } else {
            this.pageCount = 0
            _this.util.error(res.msg)
          }
          this.$nextTick(() => {
            this.initCheckData()
          })
        })

      // }
    },
    delete (arr, node) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == node.id) {
          arr.splice(i, 1)
        }
      }
    },
    cancel () {
      this.$store.state.selectProjectNode = {}
      this.selectMemberModels.isShow = false
    },
    cancelSelect (row) {

      // console.log('--------',row)
      this.selectList = this.selectList.filter(item=>{
        return item.id !== row.id
      })
      this.$nextTick(() => {
        this.initCheckData()
      })
      return
    },
    success () {
      this.selectMemberModels.selectList = this.selectList
      this.selectMemberModels.callBack()
      this.cancel()
    },
    handlerLinkSelect (selection, row) {
      // console.log('-----handleLinkSelect-----',selection,row)

    },
    handlerLinkChange (selection) {
      // console.log(this.initing + '-----handleLinkChange-----',selection)
      this.handlerTableSelectionChange(selection)
    },
    handleSelectionChange (selection) {
      // console.log(this.initing + '-----handleSelectionChange-----',selection)
      this.handlerTableSelectionChange(selection)

    },
    handlerTableSelectionChange(selection){
      //console.log(this.initing + '-----handlerTableSelectionChange-----',selection,this.userList)

      if(this.initing){
        return
      }
      let oldSelectedData = []
      if(this.activeName === '常用联系人'){
        oldSelectedData = this.commonlySelectList
      }else if (this.activeName  === '项目') {

      } else{
        // oldSelectedData = this.userList
        oldSelectedData = this.selectedSelection[this.selectNode.id]?(this.selectedSelection[this.selectNode.id][this.pageIndex]?this.selectedSelection[this.selectNode.id][this.pageIndex]:[]) : []
      }
      // console.log('-----oldSelectedData----',oldSelectedData)
      let deleteData = []
      // 先查找已经移除的
      if(oldSelectedData && oldSelectedData.length>0){
        if(selection.length === 0){
          deleteData = oldSelectedData
        }else{
          oldSelectedData.forEach(item=>{
            let existUser = selection.filter(u => {
              return u.id === item.id
            })
            // console.log('-----',item,existUser)
            if(!existUser || existUser.length == 0){
              deleteData.push(item)
            }
          })
        }
      }
      if(this.activeName === '常用联系人'){
        this.commonlySelectList = selection
      }else if (this.activeName === '项目') {

      } else{
        this.userList = selection
        if(!this.selectedSelection[this.selectNode.id]){
          this.selectedSelection[this.selectNode.id] = {}
        }
        this.selectedSelection[this.selectNode.id][this.pageIndex] = selection
      }
      selection.forEach(item=>{
        let existUser = this.selectList.filter(u => {
          return u.id === item.id
        })
        // console.log('-----',item,existUser)
        if(!existUser || existUser.length === 0){
          this.selectList.push(item)
        }
      })
      // console.log('----deleteData----',deleteData)
      // 判断是否取消勾选
      deleteData.forEach( item => {
        this.selectList = this.selectList.filter( u => {
          return item.id !== u.id
        })

      })
    }
  }
}
</script>
<style scoped>
.modal-content{
  height: 500px;
}
.active::after {
    background: #3B8CFF!important;
}
.mask-box{
    width: 100%;height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
}
.querter-box{
    width: 775px;
    transform: translate(-50%,-50%);
    position: fixed;
    left: 50%;
    top: 50%;
    background: #fff;
    border-radius: 5px ;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    height: 500px;
    z-index: 999;
    overflow: hidden;
}
.querter-list-box{
    width: 220px;
    height: 100%;
    box-sizing: border-box;
    padding:68px 10px 70px;
  padding-right: 0px;
    overflow: hidden;
    float: left;
}
.querter-list-box h4{
    position: absolute;
    left: 10px;
    top:0px;
}
.footer-btn{
    position: absolute;
    bottom: 20px;
    right: 20px;
}
.item-box{
    width: 100%;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    overflow: auto;
    border: 1px solid #E7E7E7;
}
.select-list{
    width: 295px;
    height: 100%;
    float: left;
    padding: 68px 10px 70px;
    box-sizing: border-box;
    position: relative;
}
.select-list1{
    position: absolute;
    width: 272px;
    right: 0;
    top: 0;
}
.select-list2{
    width: 515px;
}
.select-list h4{
    position: absolute;
    left: 20px;
    top: 0;
}
.tab{
    position: absolute;top: 0;
    left: 10px;
    z-index: 99;
}
.tab>div{
    float: left;
    padding: 20px 10px;
}
.active{
    position: relative;
}
.active::after{
    content: '';
    position: absolute;
    width: 100%;
    bottom: -6px;
    left: 0;
    height: 2px;
    background: #F08B00;
}
.search{
    position: absolute;
    z-index: 99;
    width: auto;
    left: 340px;
    border: 0;
    top: -5px;
}
img {
    vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/common/select-user/select-user.vue